import { MODULE_CAPABILITIES } from '../../editCourse/moduleConfig';

/**
 * Mock content definitions for each module type.
 * Used for previews in Step 3 and for populating courses after the guide.
 */
export const MOCK_CONTENT = {
  text: {
    previewContentKey: 'courseGuide.modulePreview.text',
    descriptionKey: 'courseGuide.moduleDesc.text',
  },
  image: {
    previewCaptionKey: 'courseGuide.modulePreview.image',
    descriptionKey: 'courseGuide.moduleDesc.image',
  },
  video: {
    previewCaptionKey: 'courseGuide.modulePreview.video',
    descriptionKey: 'courseGuide.moduleDesc.video',
  },
  audio: {
    previewCaptionKey: 'courseGuide.modulePreview.audio',
    descriptionKey: 'courseGuide.moduleDesc.audio',
  },
  embed: {
    previewCaptionKey: 'courseGuide.modulePreview.embed',
    descriptionKey: 'courseGuide.moduleDesc.embed',
  },
  task: {
    previewCaptionKey: 'courseGuide.modulePreview.task',
    descriptionKey: 'courseGuide.moduleDesc.task',
  },
  download: {
    previewCaptionKey: 'courseGuide.modulePreview.download',
    descriptionKey: 'courseGuide.moduleDesc.download',
  },
  discussion: {
    previewCaptionKey: 'courseGuide.modulePreview.discussion',
    descriptionKey: 'courseGuide.moduleDesc.discussion',
  },
  slideshow: {
    previewCaptionKey: 'courseGuide.modulePreview.slideshow',
    descriptionKey: 'courseGuide.moduleDesc.slideshow',
  },
  webinar: {
    previewCaptionKey: 'courseGuide.modulePreview.webinar',
    descriptionKey: 'courseGuide.moduleDesc.webinar',
  },
};

/**
 * Get mock content ready for the createPageModule API call.
 * @param {string} moduleType
 * @param {Function} t - i18next translation function
 * @returns {Object} { content, params, sources, caption }
 */
export const getMockContentForApi = (moduleType, t) => {
  const result = {};

  switch (moduleType) {
    case 'text':
      result.content = JSON.stringify(
        `<h2>${t('courseGuide.mock.text.heading')}</h2>` +
        `<p>${t('courseGuide.mock.text.paragraph1')}</p>` +
        `<p>${t('courseGuide.mock.text.paragraph2')}</p>`
      );
      break;

    case 'image':
      result.params = { caption: t('courseGuide.mock.image.caption') };
      break;

    case 'video':
      result.params = { caption: t('courseGuide.mock.video.caption') };
      break;

    case 'audio':
      result.params = { caption: t('courseGuide.mock.audio.caption') };
      break;

    case 'embed':
      result.params = { caption: t('courseGuide.mock.embed.caption') };
      break;

    case 'task':
      result.content = JSON.stringify(t('courseGuide.mock.task.body'));
      result.params = { caption: t('courseGuide.mock.task.caption') };
      break;

    case 'download':
      result.params = { caption: t('courseGuide.mock.download.caption') };
      break;

    case 'discussion':
      result.content = JSON.stringify({ body: t('courseGuide.mock.discussion.body') });
      break;

    case 'slideshow':
      result.params = { caption: t('courseGuide.mock.slideshow.caption') };
      break;

    case 'webinar':
      result.params = { caption: t('courseGuide.mock.webinar.caption') };
      break;

    default:
      break;
  }

  return result;
};

/**
 * Get the module icon and label from moduleConfig for display.
 */
export const getModuleDisplayInfo = (moduleType) => {
  const cap = MODULE_CAPABILITIES[moduleType];
  if (!cap) return { icon: 'Edit', label: moduleType, labelKey: '' };
  return {
    icon: cap.icon,
    label: cap.label,
    labelKey: cap.labelKey,
  };
};
